class SingleAgency {
    constructor() {
        this.singleAgency = document.querySelector(".page-template-template-agency");
        if (!this.singleAgency) {
            return;
        }
        this.buildSwiperLightbox();
        this.buildAgencyViewsGallery();
    }

    buildSwiperLightbox() {
        lightGallery(document.querySelector('.real-swiper'), {
            speed: 500,
            selector: ".img-container",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001'
        });
    }

    buildAgencyViewsGallery() {
        lightGallery(document.querySelector('.gallery-agency'), {
            speed: 500,
            selector: ".img-container",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001'
        });
    }
}